module.exports = __webpack_public_path__ + "fcafd3ecf40a73701c526c473558861b.png";